import { render, staticRenderFns } from "./borrower-not-uploading-reason-modal.vue?vue&type=template&id=4209c783&"
import script from "./borrower-not-uploading-reason-modal.vue?vue&type=script&lang=ts&"
export * from "./borrower-not-uploading-reason-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports